import React from 'react';
import Colors from '../../library/Colors';
import { belgianDates } from './dateFormat';

/**
 * KPI tiles: [{key, label, value, value2?, value2_label?, unit?, delta?, previous?}]
 * delta is a percentage vs the previous period (null when the previous period was 0).
 */
const fmt = (v) => {
  if (v === null || typeof v === 'undefined') return '–';
  if (typeof v === 'number') return v.toLocaleString('nl-BE', { maximumFractionDigits: 1 });
  return String(v);
};

export default function StatsTiles({ tiles, theme, t }) {
  if (!tiles || !tiles.length) return null;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 10, margin: '6px 0 14px' }}>
      {tiles.map((tile) => {
        const hasDelta = typeof tile.delta !== 'undefined';
        const up = hasDelta && tile.delta !== null && tile.delta > 0;
        const down = hasDelta && tile.delta !== null && tile.delta < 0;
        return (
          <div key={tile.key} className={theme} style={{ border: '1px solid rgba(128,128,128,0.35)', borderRadius: 6, padding: '10px 12px', background: 'rgba(128,128,128,0.06)' }}>
            <div style={{ fontSize: 26, fontWeight: 700, lineHeight: 1.1, fontVariantNumeric: 'tabular-nums' }}>
              {fmt(tile.value)}{tile.unit ? <span style={{ fontSize: 14, marginLeft: 2 }}>{tile.unit}</span> : null}
              {typeof tile.value2 !== 'undefined' && tile.value2 !== null && (
                <span style={{ fontSize: 13, fontWeight: 400, marginLeft: 8, opacity: 0.75 }}>{fmt(tile.value2)} {belgianDates(tile.value2_label || '')}</span>
              )}
            </div>
            <div style={{ fontSize: 13, opacity: 0.8, marginTop: 4 }}>{belgianDates(tile.label)}</div>
            {hasDelta && (
              <div style={{ fontSize: 12, marginTop: 4, color: up ? '#1f7a4d' : down ? '#b02a2a' : 'inherit', opacity: tile.delta === null ? 0.6 : 1 }} title={`${t ? t('stats_vs_previous') : 'vs vorige periode'}: ${fmt(tile.previous)}`}>
                {tile.delta === null ? '—' : `${up ? '▲' : down ? '▼' : '='} ${Math.abs(tile.delta)} %`}
                <span style={{ opacity: 0.6, marginLeft: 6 }}>({fmt(tile.previous)})</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export { fmt, Colors };
